import { log } from "../utils/logging";

export class ApiProvider{
    constructor(instance, account){
        this._instance = instance;
        this._account = account;
    }

    async Get(path, params, contentType, isFile){
        log.trace('called GET at path: ', path);
        return this.callAPI(path, 'GET', params, contentType, isFile)
    };
    async Post(path, params, contentType, isFile){
        log.trace('called POST at path: ', path);
        return this.callAPI(path, 'POST', params, contentType, isFile); 
    };
    async Put(path, params, contentType, isFile){
        log.trace('called PUT at path: ', path);
        return this.callAPI(path, 'PUT', params, contentType, isFile); 
    };
    async Patch(path, params, contentType, isFile){
        log.trace('called PATCH at path: ', path);
        return this.callAPI(path, 'PATCH', params, contentType, isFile);
    };
    async Delete(path, params, contentType, isFile){
        log.trace('called DELETE at path: ', path);
        return this.callAPI(path, 'DELETE', params, contentType, isFile);
    };

    async callAPI(path, verb, params, contentType, isFile){ 
        const request = {
            scopes: ["api://inHouseApi/access"],
            account: this._account
        }
        var token;
        // try {
        //     token =  (await this._instance.acquireTokenSilent(request)).accessToken;
        // } catch {
        //     token = (await this._instance.acquireTokenPopup(request)).accessToken;
        // }
        if(!window.language){
            window.language = 'en';
        }
        if(!contentType){
            contentType = "application/json";
            params = params ? JSON.stringify(params) : null
        }

        const headers = new Headers();
        //const bearer = `Bearer ${token}`;

        //headers.append("Authorization", bearer);
        headers.append("Accept","*/*");
        if(contentType !== "multipart/form-data")
            headers.append("Content-Type", contentType);
        headers.append("Content-Language", window.language);

        const options = {
            method: verb,
            headers: headers,
            body: params
        };

        if(!window.env){
            await fetch('/settings.json',{
                headers : { 
                'Content-Type': 'application/json',
                'Accept': 'application/json'
                }
            })
            .then(response =>  {
                return response.json();
                })
            .then((data) => window.env = data )
            .catch(error => console.log(error));
        }

        path = window.env["baseUrl"] + path;

        const response = await fetch(path, options).catch(error => {console.log(error); return error;});
        log.trace('fetch response', response);

        const contentTypeText = response.headers && response.headers.get('content-type') ? response.headers.get('content-type') : '';
        const responseContentType = {
            isJson: contentTypeText.indexOf('application/json') !== -1,
            isText: contentTypeText.indexOf('text/plain') !== -1,
            isPdf: contentTypeText.indexOf('application/pdf') !== -1,
            isProblemJson: contentTypeText.indexOf('application/problem+json') !== -1,
        }
        

        if (response.ok) {

            if (isFile === true)
                return await response.blob();

            if (responseContentType.isJson) {
                return await response.json();
            } 
            else if(responseContentType.isText) {
                return await response.text();
            } 
            else if(responseContentType.isPdf) {
                return await response.text();
            }
            return "";
        } 
        
        if(response.ok === false){

            let customMessage = '';

            if (response.status === 404) {
                customMessage = `404 Unable to locate resource at ${path}`;
            }
            else {
                if (responseContentType.isProblemJson || responseContentType.isJson) {
                    const responsBody = await response.json();
                    log.trace('response body responsBody', responsBody);
                    customMessage = responsBody.detail ?? responsBody.error ?? responsBody.errors?.input ?? responsBody.errors?.Code ?? JSON.stringify(responsBody.errors);
                }
                else {
                    const responseText = await response.text();
                    log.trace('response body responseText', responseText);
                    customMessage = responseText == null || responseText === '' ? "Something went wrong" : responseText;
                }
            }

            alert(customMessage);
            const responseError = {
                type: 'Error',
                message: response.message || customMessage,
                data: response.data || '',
                code: response.status || '',
            };   
            let error = new Error();
            error = { ...error, ...responseError };
            return {error: error};
        }

        return {error: response};
    }
}